import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CustomerInfoCard = ({ applicationData }) => {
  const [copiedField, setCopiedField] = useState(null);

  const copyToClipboard = (text, fieldName) => {
    navigator?.clipboard?.writeText(text)?.then(() => {
      setCopiedField(fieldName);
      setTimeout(() => setCopiedField(null), 2000);
    });
  };

  const formatVoucherCode = (code) => {
    if (!code) return 'Wird generiert...';
    // Format as XXXX-XXXX-XXXX
    return code?.match(/.{1,4}/g)?.join('-') || code;
  };

  return (
    <div className="bg-gradient-to-br from-success via-success/90 to-success/80 rounded-xl p-6 md:p-8 mb-8 shadow-2xl">
      <div className="flex items-start gap-4 md:gap-6">
        <div className="flex-shrink-0">
          <div className="w-16 h-16 md:w-20 md:h-20 bg-white rounded-full flex items-center justify-center shadow-lg">
            <Icon name="FileCheck" size={40} color="var(--color-success)" />
          </div>
        </div>
        <div className="flex-1">
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-4">
            <h2 className="font-heading font-bold text-white text-xl md:text-2xl">
              ✓ Fahrzeugschein & FIN erfolgreich übermittelt
            </h2>
            <span className="px-3 py-1.5 bg-white rounded-full text-xs md:text-sm font-bold text-success shadow-md w-fit">
              BESTÄTIGT
            </span>
          </div>

          {/* Customer Information Grid */}
          <div className="bg-white/95 rounded-lg p-4 md:p-6 space-y-4 shadow-lg">
            {/* Customer Number */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Hash" size={22} color="var(--color-success)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">Kundennummer</p>
                <div className="flex items-center gap-2">
                  <p className="text-base md:text-lg font-mono font-bold text-success truncate">
                    {applicationData?.id?.substring(0, 8)?.toUpperCase()}
                  </p>
                  <button
                    onClick={() => copyToClipboard(applicationData?.id, 'customerNumber')}
                    className="p-1.5 hover:bg-muted rounded transition-smooth flex-shrink-0"
                    title="Kopieren"
                  >
                    {copiedField === 'customerNumber' ? (
                      <Icon name="Check" size={16} color="var(--color-success)" />
                    ) : (
                      <Icon name="Copy" size={16} color="var(--color-muted-foreground)" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Voucher Code Email Notice */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Mail" size={22} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">Gutscheincode</p>
                <p className="text-base md:text-lg font-bold text-foreground">
                  Wird per E-Mail nach erfolgreichem Abschluss gesendet
                </p>
              </div>
            </div>

            {/* Chassis Number (FIN) */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="Car" size={22} color="var(--color-success)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">Fahrgestellnummer (FIN)</p>
                <p className="text-base md:text-lg font-mono font-bold text-success truncate">
                  {applicationData?.chassis_number}
                </p>
              </div>
            </div>

            {/* Vehicle Document Status */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                <Icon name="FileText" size={22} color="var(--color-success)" />
              </div>
              <div className="flex-1">
                <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wide">Fahrzeugschein</p>
                <p className="text-base font-bold text-foreground">Hochgeladen und gespeichert</p>
              </div>
            </div>
          </div>

          {/* Security Notice */}
          <div className="mt-4 p-4 bg-white/90 rounded-lg border-2 border-white/50 shadow-md">
            <div className="flex items-start gap-3">
              <Icon name="ShieldCheck" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-bold text-foreground mb-1">Ihre Fahrzeugdaten sind sicher gespeichert</p>
                <p className="text-xs text-muted-foreground">
                  Der Fahrzeugschein und die Fahrgestellnummer wurden erfolgreich in unserem System hinterlegt und werden 
                  ausschließlich für die Bearbeitung Ihres THG-Antrags verwendet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerInfoCard;